<template>
  <div class="mfix" :class="{ mmm: !show ,['h'+shop.idx]:true}">
    <div class="tool flex ac">
      <div style="flex: 1; padding-right: 20px; text-align: right">
        <span class="el-icon-error po f18" @click="hide"></span>
      </div>
    </div>
    <webviewnowin
      :ref="'webviewnowin-' + shop.id + '-' + shop.idx"
      @onCompleted="onCompleted"
    ></webviewnowin>
  </div>
</template>
<script>
import webviewnowin from "@/views/admin/com/webviewnowin.vue";
export default {
  components: {
    webviewnowin,
  },
  props: {
    shop: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      show: true,
    };
  },
  methods: {
    onCompleted: function (details) {
      console.log("=====================请求onCompleted",JSON.parse(JSON.stringify(details)))
    },
    hide: function () {
      this.show = false;
    },
    show: function () {
      this.show = true;
    },
    getKey: function () {
      let key = "webviewnowin-" + this.shop.id + "-" + this.shop.idx;
      return key;
    },
    getInstanceKey: function () {
      let key = "$instance-" + this.shop.id + "-" + this.shop.idx;
      return key;
    },
    init: async function () {
      let key = this.getKey();
      this.$refs[key].setStyle({
        width: "1000px",
        height: "600px",
      });
      return await this.$refs[key].open(this.shop);
    },
    removeShop: function (shopId) {
      console.log("===============进来删除了", shopId);
      let keys = Object.keys(window);
      for (let i = 0; i < keys.length; i++) {
        let k = keys[i];
        if (k.includes("$instance-" + shopId)) {
          let key = k;
          if (window[key]) {
            window[key].$destroy();
            window[key].$el.parentNode.removeChild(window[key].$el);
            window[key] = undefined;
          }
        }
      }
    },
    goPage: async function (shop, url) {
      let key = this.getInstanceKey();
      if (window[key]) {
        let key2 = this.getKey();
        let rs = await this.$refs[key2].goPage(url);
        console.log("======================webview返回结果", rs);
        return rs;
      } else {
        return { code: -1, msg: "webview还未初始化好" };
      }
    },
    publish: async function (shop, schema) {
      // this.show = true;
      let key = this.getInstanceKey();
      if (window[key]) {
        let key2 = this.getKey();
        let rs = await this.$refs[key2].publish(shop, schema);
        console.log("======================webview返回结果", rs);
        return rs;
      } else {
        return { code: -1, msg: "webview还未初始化好" };
      }
    },
    editPublish: async function (shop, schema) {
      // this.show = true;
      let key = this.getInstanceKey();
      if (window[key]) {
        let key2 = this.getKey();
        let rs = await this.$refs[key2].editPublish(shop, schema);
        console.log("======================webview返回结果", rs);
        return rs;
      } else {
        return { code: -1, msg: "webview还未初始化好" };
      }
    },
    callMethod: async function (action, params) {
      let { shop } = params;
      let key = this.getInstanceKey();
      if (window[key]) {
        let key2 = this.getKey();
        let rs = await this.$refs[key2].callMethod(action, params);
        console.log("======================webview返回结果", rs);
        return rs;
      } else {
        return { code: -1, msg: "webview还未初始化好" };
      }
    },
  },
};
</script>
<style scoped>
.mfix {
  position: fixed;
  left: 0px;
  z-index: 10000;
}
.h0{
  top: 100px;
}
.h1{
  top: 200px;
}
.h2{
  top: 300px;
}
.h3{
  top: 400px;
}
.h4{
  top: 500px;
}
.h5{
  top: 100px;
}
.tool {
  height: 40px;
  border: 1px solid #ececec;
  border-radius: 4px 4px 0px 0px;
  background-color: #fff;
}
.mmm {
  width: 1px;
  height: 1px;
  overflow: hidden;
}
</style>
